// extracted by mini-css-extract-plugin
export var iconDown = "selectMenu-module--iconDown--8028e";
export var iconUp = "selectMenu-module--iconUp--f18b1";
export var iconWarning = "selectMenu-module--iconWarning--6ceb3";
export var warning = "selectMenu-module--warning--56c16";
export var wrapper = "selectMenu-module--wrapper--15bf1";